import { useState } from "react";
import { Menu, X } from "lucide-react";
import { LOGO, NAV, WA_LINK } from "@/components/site/content";

export const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-black/90 backdrop-blur-md border-b border-white/5">
      <div className="max-w-7xl mx-auto px-5 h-16 flex items-center justify-between gap-6">
        <a href="#home" data-testid="site-logo-link"><img src={LOGO} alt="DaddyAnna Online Cricket ID" className="h-9 w-auto" /></a>
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map(([label, href]) => (
            <a key={href} href={href} data-testid={`site-nav-${href.slice(1)}`}
              className="text-sm font-semibold text-white/90 hover:text-[#ffcc00] transition-colors">{label}</a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a href={WA_LINK} data-testid="header-get-id-button" className="da-btn-purple text-sm px-5 py-2">Get ID Now</a>
          <button className="lg:hidden p-2 text-white" data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)} aria-label="Menu">
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="lg:hidden border-t border-white/10 bg-black px-5 py-4 flex flex-col gap-3" data-testid="mobile-menu">
          {NAV.map(([label, href]) => (
            <a key={href} href={href} onClick={() => setOpen(false)} className="font-semibold text-white/90 hover:text-[#ffcc00]">{label}</a>
          ))}
        </nav>
      )}
    </header>
  );
};
